"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const CoreContext_1 = require("../_InternalComponents/CoreContext");
const isDomainDifferent_1 = require("../_InternalUtils/isDomainDifferent");
const InfoCardSubjectSkeleton_1 = tslib_1.__importDefault(require("./InfoCardSubjectSkeleton"));
const getStyles = () => ({
    userInfoText: {
        marginBottom: (theme) => theme.spacing(0.5),
    },
});
const InfoCardSubjectContent = (props) => {
    const { loading, subject } = props;
    const styles = getStyles();
    const contextDomain = react_1.default.useContext(CoreContext_1.CoreContext)?.domain;
    // Return a loading skeleton if loading === true
    if (loading)
        return react_1.default.createElement(InfoCardSubjectSkeleton_1.default, { animation: "wave", variant: "text" });
    // Return user information if user exists. Also check if extended info should be shown.
    if (subject)
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: styles.userInfoText }, subject.name),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, (0, isDomainDifferent_1.isDomainDifferent)(contextDomain, subject?.domain) && subject?.domain?.name),
            react_1.default.createElement(Typography_1.default, { color: "textSecondary", sx: styles.userInfoText }, subject.customer?.name)));
    // Return an empty skeleton if loading && user === false
    return react_1.default.createElement(InfoCardSubjectSkeleton_1.default, { animation: false, variant: "text" });
};
exports.default = InfoCardSubjectContent;
